<template>
  <div>
    <div v-if="preloader">
      <div
        class="d-flex align-center justify-center flex-column"
        style="height: 100vh"
      >
        <bubble-loader />
      </div>
    </div>
    <div v-else>
      <div class="custom-container pt-6">
        <v-card
          height="64px"
          width="100%"
          class="background mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
          style="
            position: fixed;
            z-index: 200;
            top: 0;
            width: 98%;
            padding-top: 16px;
          "
        >
          <v-card-title class="ml-0 pl-0">
            <p class="breadcrumb-text">Dashboard</p>
            <span
              ><v-icon class="breadcrumb-arrow">mdi-chevron-down</v-icon></span
            >
          </v-card-title>
          <UserNavMenu />
        </v-card>
        <v-row align="stretch" class="px-4">
          <v-col cols="12" sm="6" md="6" class="d-flex flex-column">
            <div class="d-flex align-center justify-space-between">
              <!-- Date Label with Arrows -->
              <div class="d-flex align-center text-h6 font-weight-bold gap-4">
                <div>{{ periodLabel }}</div>
                <img
                  src="../assets/previous.svg"
                  alt="Previous"
                  class="icon"
                  :class="{ 'disabled-icon': isPreviousDisabled }"
                  @click="!isPreviousDisabled && goToPreviousPeriod()"
                />

                <img
                  src="../assets/neXt.svg"
                  alt="Next"
                  class="icon"
                  :class="{ 'disabled-icon': isNextDisabled }"
                  @click="!isNextDisabled && goToNextPeriod()"
                />
              </div>
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="6" class="d-flex justify-end gap-4">
            <v-btn-toggle v-model="activeTab" mandatory dense rounded>
              <v-btn
                width="100px"
                class="no-uppercase"
                :class="
                  activeTab == 0
                    ? 'custom-gray-text blue--text text-subtitle-2 '
                    : 'blue--text text-subtitle-2'
                "
              >
                Week
              </v-btn>
              <v-btn
                width="100px"
                class="no-uppercase"
                :class="
                  activeTab == 1
                    ? 'custom-gray-text blue--text text-subtitle-2'
                    : ' blue--text text-subtitle-2'
                "
              >
                Month
              </v-btn>
            </v-btn-toggle>
            <v-autocomplete outlined label="View Mode" v-model="viewMode" :items="viewModeList" @change="getChartData">
            </v-autocomplete>
            <v-btn
              @click="filterDialog = true"
              dense
              rounded
              class="btn outline-btn elevation-0"
              ><v-icon class="pr-2">mdi-tune</v-icon>
              <span v-if="filterCount > 0">Filter ({{ filterCount }})</span>
              <span v-else>Filter</span>
            </v-btn>
          </v-col>
        </v-row>

        <v-row align="stretch" class="px-4">
          <v-col
            cols="12"
            sm="6"
            :md="windowWidth <= breakpoint ? 6 : 4"
            class="d-flex flex-column"
          >
            <v-card
              class="pa-4 d-flex flex-column"
              elevation="2"
              v-if="registered.isDataAvailable"
            >
              <div class="d-flex justify-space-between align-center">
                <div>
                  <span class="chart-title"> Candidate Registration </span>
                  <div style="font-size: 12px">Number of candidates registered</div>
                </div>
                <v-btn
                  icon
                  @click="downloadChartData('registered')"
                  :loading="downloadLoaders.registered"
                  ><v-img src="../assets/svg/import-icon.svg"  /></v-btn
                >
              </div>
              <div
                class="flex-grow-1 d-flex justify-center align-center"
                :class="windowWidth <= 1232 ? 'pt-10' : ''"
              >
                <CandidateRegistration
                  :labels="registered.label"
                  :datasetData="registered.data"
                  :totalRegistered="registered.totalRegistered"
                  :activeTab="activeTab"
                />
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
              style="min-height: 300px"
            >
              <span class="chart-title"> Candidate Registration </span>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            :md="windowWidth <= breakpoint ? 6 : 4"
            class="d-flex flex-column"
          >
            <v-card
              class="pa-4 d-flex flex-column"
              elevation="2"
              v-if="
                testRound.isMainsDataAvailable &&
                testRound.isScreeningDataAvailable
              "
            >
              <div
                class="d-flex justify-space-between align-center"
                style="width: 100%"
              >
                <div>
                  <span class="chart-title"> Test Rounds- Pass vs Fail </span>
                  <div style="font-size: 12px">
                    Pass and Fail distribution per round
                  </div>
                </div>
                
                <div class="d-flex justify-end mt-2">
                  <v-btn-toggle v-model="activeTestTab" mandatory dense rounded class="mr-2">
                    <v-btn
                      width="100px"
                      class="no-uppercase"
                      :class="
                        activeTestTab == 0
                          ? 'custom-gray-text blue--text text-subtitle-2'
                          : 'blue--text text-subtitle-2'
                      "
                    >
                      Screening
                    </v-btn>
                    <v-btn
                      width="100px"
                      class="no-uppercase"
                      :class="
                        activeTestTab == 1
                          ? 'custom-gray-text blue--text text-subtitle-2'
                          : ' blue--text text-subtitle-2'
                      "
                    >
                      Mains
                    </v-btn>
                  </v-btn-toggle>
                  <v-btn
                    icon
                    @click="downloadChartData('testRound')"
                    :loading="downloadLoaders.testRound"
                    ><v-img src="../assets/svg/import-icon.svg"  /></v-btn
                  >
                </div>
              </div>


              <!-- Chart stays centered below -->
              <div class="flex-grow-1 d-flex justify-center align-center">
                <BarChart
                  :chart-data="{
                    labels: testRound.label,
                    datasets: [
                      {
                        label: 'Pass',
                        backgroundColor: '#8CE2A9',
                        data: testRoundPassed.map((v) => (v === 0 ? null : v)),
                      },
                      {
                        label: 'Fail',
                        backgroundColor: '#F7C3BB',
                        data: testRoundFailed.map((v) => (v === 0 ? null : v)),
                      },
                    ],
                  }"
                  :stacked="true"
                  :enable-data-labels="true"
                  :mainsTotalFailed="
                    activeTestTab === 1 ? testRound.mainsTotalFailed : null
                  "
                  :mainsTotalPassed="
                    activeTestTab === 1 ? testRound.mainsTotalPassed : null
                  "
                  :screeningTotalFailed="
                    activeTestTab === 0 ? testRound.screeningTotalFailed : null
                  "
                  :screeningTotalPassed="
                    activeTestTab === 0 ? testRound.screeningTotalPassed : null
                  "
                  :activeTab="activeTab"
                />
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
              style="min-height: 300px"
            >
              <span class="chart-title"> Test Rounds- Pass vs Fail </span>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="d-flex flex-column">
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-if="demoCompletion.isDataAvailable"
            >
              <div class="d-flex justify-space-between align-center">
                <div>
                  <span class="chart-title"> Demo Completed </span>
                  <div style="font-size: 12px">Demo completed by candidates</div>
                </div>
                <v-btn
                  icon
                  @click="downloadChartData('demoCompletion')"
                  :loading="downloadLoaders.demoCompletion"
                  ><v-img src="../assets/svg/import-icon.svg"  /></v-btn
                >
              </div>
              <div class="flex-grow-1 d-flex justify-center align-center">
                <BarChart
                  :chart-data="{
                    labels: demoCompletion.label,
                    datasets: [
                      {
                        label: 'Demo Completed',
                        backgroundColor: '#AC9EE4',
                        data: demoCompletion.demoCompletion.map((v) =>
                          v === 0 ? null : v
                        ),
                      },
                    ],
                  }"
                  :enable-data-labels="true"
                  :demoTotalCompletion="demoCompletion.demoTotalCompletion"
                  :activeTab="activeTab"
                />
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
              style="min-height: 300px"
            >
              <span class="chart-title"> Demo Completed </span>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>

          <!-- <v-row align="stretch" class="px-4"> -->
          <v-col
            cols="12"
            sm="6"
            :md="windowWidth <= breakpoint ? 4 : 6"
            class="d-flex flex-column"
          >
            <v-card
              class="pa-4 d-flex flex-column"
              elevation="2"
              v-if="interviewProgression.isDataAvailable"
            >
              <div class="d-flex justify-space-between align-center">
                <div>
                  <span class="chart-title"> Interview Progress Preview </span>
                  <div style="font-size: 12px">
                    Current stages of candidate interviews
                  </div>
                </div>
                <v-btn
                  icon
                  @click="downloadChartData('interviewProgression')"
                  :loading="downloadLoaders.interviewProgression"
                  ><v-img src="../assets/svg/import-icon.svg"  /></v-btn
                >
              </div>
              <div class="flex-grow-1 d-flex justify-center align-center">
                <InterviewProgress
                  :labels="interviewProgression.label"
                  :interviewTotalCompletion="
                    interviewProgression.interviewTotalCompletion
                  "
                  :interviewTotalSendToHiringManager="
                    interviewProgression.interviewTotalSendToHiringManager
                  "
                  :activeTab="activeTab"
                  :datasets="[
                    {
                      label: 'Interviewed',
                      backgroundColor: '#439AFF',
                      data: interviewProgression.interviewCompletion,
                      borderColor: '#439AFF',
                      backgroundColor: 'transparent', // ✅ No fill under the line

                      pointBackgroundColor: '#439AFF99', // Optional: point color
                      pointBorderColor: '#439AFF99', //
                      pointRadius: 5, // ✅ Increase dot size (default is 3)
                      pointHoverRadius: 10,
                    },
                    {
                      label: 'Send to Hiring Manager',
                      backgroundColor: '#439AFF',
                      data: interviewProgression.interviewSendToHiringManager,
                      borderColor: '#5AD684', // ✅ Line color
                      backgroundColor: 'transparent', // ✅ No fill under the line

                      pointBackgroundColor: '#5AD68499', // Optional: point color
                      pointBorderColor: '#5AD68499', //
                      pointRadius: 5, // ✅ Increase dot size (default is 3)
                      pointHoverRadius: 10,
                    },
                  ]"
                />
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
              style="min-height: 300px"
            >
              <span class="chart-title"> Interview Progress Preview </span>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            :md="windowWidth <= breakpoint ? 4 : 6"
            class="d-flex flex-column"
          >
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-if="hiringmanagerCompletion.isDataAvailable"
            >
              <div class="d-flex justify-space-between align-center">
                <div>
                  <span class="chart-title"> Hiring Decision Overview </span>
                  <div style="font-size: 12px">
                    Final candidate selection summary overview
                  </div>
                </div>
                <v-btn
                  icon
                  @click="downloadChartData('hiringmanagerCompletion')"
                  :loading="downloadLoaders.hiringmanagerCompletion"
                  ><v-img src="../assets/svg/import-icon.svg"  /></v-btn
                >
              </div>
              <div class="flex-grow-1 d-flex justify-center align-center">
                <HiringDecisionOverview
                  :labels="hiringmanagerCompletion.label"
                  :interviewTotalAccepted="
                    hiringmanagerCompletion.interviewTotalAccepted
                  "
                  :interviewTotalRejected="
                    hiringmanagerCompletion.interviewTotalRejected
                  "
                  :activeTab="activeTab"
                  :datasets="[
                    {
                      label: 'Rejected',
                      data: hiringmanagerCompletion.interviewRejected,
                      borderColor: '#F5B4AA', // ✅ Line color
                      backgroundColor: '#F5B4AA99',
                      fill: true,

                      pointBackgroundColor: '#F5B4AA99',
                      pointBorderColor: '#F5B4AA99', //
                      pointRadius: 5, // ✅ Increase dot size (default is 3)
                      pointHoverRadius: 10,
                    },
                    {
                      label: 'Accepted',
                      data: hiringmanagerCompletion.interviewAccepted,
                      borderColor: '#5AD684', // ✅ Line color
                      backgroundColor: '#5AD68466',
                      fill: true,

                      pointBackgroundColor: '#5AD68499', // Optional: point color
                      pointBorderColor: '#5AD68499', //
                      pointRadius: 5, // ✅ Increase dot size (default is 3)
                      pointHoverRadius: 10,
                    },
                  ]"
                />
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
              style="min-height: 300px"
            >
              <span class="chart-title"> Hiring Decision Overview </span>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-dialog v-model="filterDialog" class="cdz" max-width="570px">
          <v-card width="570px" height="100vh" class="filterDialogClass d-flex flex-column">
            <v-row class="mt-4 mx-1">
              <v-col>
                <div class="pl-0 mb-2 text-body1 font-weight-bold grey--text">
                  Filter
                </div>
              </v-col>
              <v-col class="d-flex justify-end">
                <div @click="clearFilter" class="clear-filter-btn">
                  CLEAR FILTER
                </div>
              </v-col>
            </v-row>

            <v-tabs vertical>
              <div class="ml-3 mt-4 mr-4 filterLine">
                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <div class="tab-content">
                    <span>Campaign</span>
                    <span v-if="selectedCampaignFilter.length > 0" class="ml-1"
                      ><div class="status-count-badge">
                        <p>1</p>
                      </div></span
                    >
                  </div>
                </v-tab>
                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <div class="tab-content">
                    <span>Group</span>
                    <span v-if="selectedGroupFilter.length > 0">
                      <div class="status-count-badge">
                        <p>
                          {{ selectedGroupFilter.length }}
                        </p>
                      </div>
                    </span>
                  </div>
                </v-tab>

                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <div class="tab-content">
                    <span>School</span>
                    <span v-if="selectedSchoolFilter.length > 0" class="ml-1"
                      ><div class="status-count-badge">
                        <p>{{ selectedSchoolFilter.length }}</p>
                      </div></span
                    >
                  </div>
                </v-tab>
              </div>
              <v-tab-item>
                <v-card flat height="580px" class="d-flex flex-column">
                  <v-card-text>
                    <v-text-field
                      v-model="searchCampaignTerm"
                      label="Search Here..."
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      class="px-4"
                    />
                    <!-- "All" Chip (outside of chip group) -->
                    <!-- <v-chip
                      class="mb-2"
                      :class="{ 'active-chip': isAllCampaignSelected }"
                      @click="toggleAllCampaignSelection"
                      elevated
                    >
                      All
                    </v-chip> -->

                    <!-- Chip Group -->
                    <v-chip-group
                      v-model="selectedCampaignFilter"
                      column
                      active-class="active-chip"
                    >
                      <v-chip
                        v-for="(item, index) in filteredCampaignItems"
                        :key="index"
                        :value="item.id"
                        elevated
                      >
                        {{ item.name }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-text-field
                      v-model="searchGroupTerm"
                      label="Search Here..."
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      class="px-4"
                    />
                    <!-- "All" Chip (outside of chip group) -->
                    <v-chip
                      class="mb-2"
                      :class="{ 'active-chip': isAllGroupSelected }"
                      @click="toggleAllGroupSelection"
                      elevated
                    >
                      All
                    </v-chip>

                    <!-- Chip Group -->
                    <v-chip-group
                      v-model="selectedGroupFilter"
                      multiple
                      column
                      active-class="active-chip"
                    >
                      <v-chip
                        v-for="(item, index) in filteredGroupItems"
                        :key="index"
                        :value="item"
                        elevated
                      >
                        {{ item }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="680px" class="d-flex flex-column">
                  <!-- Fixed Search Section -->
                  <div class="px-4 pt-2 pb-0">
                    <v-text-field
                      v-model="searchSchoolTerm"
                      label="Search Here..."
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      class="mb-2"
                    />

                    <!-- "All" Chip (stays under the search field, not scrolled away) -->
                    <v-chip
                      class="mb-2"
                      :class="{ 'active-chip': isAllSelected }"
                      @click="toggleAllSelection"
                      elevated
                    >
                      All
                    </v-chip>
                  </div>

                  <!-- Scrollable Chips Section -->
                  <div
                    id="myScroll"
                    class="flex-grow-1 overflow-y-auto px-4 pb-4"
                    style="max-height: calc(680px - 315px)"
                  >
                    <v-chip-group
                      v-model="selectedSchoolFilter"
                      multiple
                      column
                      active-class="active-chip"
                    >
                      <v-chip
                        v-for="(item, index) in filteredItems"
                        :key="index"
                        :value="item"
                        elevated
                        class="mb-2"
                      >
                        {{ item }}
                      </v-chip>
                    </v-chip-group>
                  </div>
                </v-card>
              </v-tab-item>
            </v-tabs>

            <div class="filterDialogButton">
              <v-card-actions class="px-6 pb-3">
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  depressed
                  class="btn outline-btn font-weight-medium pa-4"
                  @click="filterDialog = false"
                  >Cancel</v-btn
                >
                <v-btn
                  rounded
                  class="btn primary-btn pa-4"
                  @click="
                    (filterDialog = false),
                      filterData(),
                      getFilterCount(),
                      (isApply = true)
                  "
                  >Apply</v-btn
                >
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import BubbleLoader from "@/components/BubbleLoader.vue";
import UserNavMenu from "@/components/UserNavMenu.vue";
import CandidateRegistration from "@/components/TrendlineDashboard/CandidateRegistrationChart.vue";
import TestRounds from "@/components/TrendlineDashboard/TestRoundsChart.vue";
import DemoCompleted from "@/components/TrendlineDashboard/DemoCompletedChart.vue";
import InterviewProgress from "@/components/TrendlineDashboard/InterviewProgressChart.vue";
import HiringDecisionOverview from "@/components/TrendlineDashboard/HiringDecisionOverviewChart.vue";
import SchoolController from "@/controllers/SchoolController";
import ChevronRight from "@/assets/neXt.svg";
import ChevronLeft from "@/assets/previous.svg";
import CampaignController from "@/controllers/CampaignController";
import BarChart from "@/components/TrendlineDashboard/BarChart.vue";
import DashboardController from "@/controllers/DashboardController";
import AudienceRolesController from "@/controllers/AudienceRolesController";
import Papa from "papaparse";

const CHART_DOWNLOAD_LABELS = {
  registered: "Candidate Registration",
  testRound: "Test Rounds",
  demoCompletion: "Demo Completed",
  interviewProgression: "Interview Progression",
  hiringmanagerCompletion: "Hiring Decision Overview",
};

export default {
  components: {
    BubbleLoader,
    UserNavMenu,
    CandidateRegistration,
    TestRounds,
    DemoCompleted,
    InterviewProgress,
    HiringDecisionOverview,
    ChevronLeft,
    ChevronRight,
    BarChart,
  },
  data() {
    return {
      preloader: false,
      filterCount: 0,
      filterDialog: false,
      selectedGroupFilter: [],
      selectedSchoolFilter: [],
      selectedCampaignFilter: [],
      schoolList: [],
      searchGroupTerm: "",
      today: new Date(),
      weekStartDate: null, // Start date of current selected week
      monthDate: null, // Any date in current selected month
      campaigns: [],
      activeTab: 0,
      activeTestTab: 0,
      startOfTheMonth: null,
      endOfTheMonth: null,
      formattedMonthDate: null,
      isPreviousDisabled: false,
      isNextDisabled: false,
      isApply: false,
      groups: [],
      demoCompletion: {},
      registered: {},
      interviewProgression: {},
      testRound: {},
      hiringmanagerCompletion: {},
      testRoundPassed: [],
      testRoundFailed: [],
      schoolsWithCode: [],
      chartCache: {},
      searchCampaignTerm: "",
      searchSchoolTerm: "",
      windowWidth: window.innerWidth,
      breakpoint: 1478,
      viewMode: "Registration-Based",
      viewModeList: [ "Registration-Based", "Completion-Based" ],
      downloadLoaders: {
        registered: false,
        testRound: false,
        demoCompletion: false,
        interviewProgression: false,
        hiringmanagerCompletion: false,
      },
    };
  },

  methods: {
    // 🔹 Shared week/month date range + filter params, used by both the chart fetch and downloads
    buildTrendlineFilters() {
      const start = this.getInitialWeekStart(this.weekStartDate);
      const end = this.getWeekEndDate(start);

      const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
      };

      let formattedStart = "";
      let formattedEnd = "";

      // 🟦 WEEK MODE
      if (this.activeTab === 0) {
        formattedStart = formatDate(start);
        formattedEnd = formatDate(end);
      }

      // 🟩 MONTH MODE
      if (this.activeTab === 1) {
        const formattedMonthDate = this.monthDate.toLocaleDateString("en-US", {
          month: "long",
          year: "numeric",
        });
        this.formattedMonthDate = formattedMonthDate;

        const [monthName, yearStr] = this.formattedMonthDate.split(" ");
        const year = parseInt(yearStr);
        const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();
        const firstDay = new Date(year, monthIndex, 1);
        const lastDay = new Date(year, monthIndex + 1, 0);

        formattedStart = formatDate(firstDay);
        formattedEnd = formatDate(lastDay);
      }

      return {
        groupFilter:
          this.selectedGroupFilter.length > 0 &&
          this.selectedGroupFilter.length < this.groups.length
            ? this.selectedGroupFilter.join(",")
            : "All",

        schoolFilter:
          this.selectedSchoolFilter.length > 0 &&
          this.selectedSchoolFilter.length <= this.schoolList.length
            ? this.schoolsWithCode
                .filter((school) =>
                  this.selectedSchoolFilter.includes(school.name)
                )
                .map((school) => school.schoolCode)
                .join(",")
            : "All",

        campaignFilter: this.selectedCampaignFilter,
        dateFormat: this.activeTab == 0 ? "week" : "month",
        start: formattedStart,
        end: formattedEnd,
        viewMode: this.viewMode || "Completion-Based",
      };
    },

    async getChartData() {
      // 🌀 Preliminary Loader for First Load
      if (!this.chartCache) {
        this.chartCache = {}; // in-memory cache (heap)
      }

      this.preloader = true;

      // 🔹 Build request body
      const requestBody = this.buildTrendlineFilters();
       console.log("Request Body for Chart Data:", requestBody);
      // 🔸 Generate a cache key
      const cacheKey = JSON.stringify({
        tab: this.activeTab,
        group: requestBody.groupFilter,
        school: requestBody.schoolFilter,
        campaign: requestBody.campaignFilter,
        start: requestBody.start,
        end: requestBody.end,
        viewMode: requestBody.viewMode,
      });

      // 🧠 Check cache first
      if (this.chartCache[cacheKey]) {
        console.log("♻️ Using cached chart data for:", cacheKey);
        const cachedData = this.chartCache[cacheKey];
        this.applyChartData(cachedData);
        this.preloader = false;
        return;
      }

      // 🔹 Fetch from API if not cached
      console.log("Fetching chart data from API...");
      const response = await DashboardController.getTrendlineChartData(
        requestBody
      );

      if (response.success) {
        // Store in cache
        this.chartCache[cacheKey] = response;

        // Apply data
        this.applyChartData(response);
      }

      this.preloader = false;
      console.log("Preloader done:", this.preloader);
    },

    // Helper function to apply data to reactive properties
    applyChartData(data) {
      this.demoCompletion = data.demoCompletion;
      this.hiringmanagerCompletion = data.hiringmanagerCompletion;
      this.interviewProgression = data.interviewProgression;
      this.registered = data.registered;
      this.testRound = data.testRound;

      if (this.activeTestTab == 0) {
        this.testRoundPassed = this.testRound.screeningPassed;
        this.testRoundFailed = this.testRound.screeningFailed;
      } else if (this.activeTestTab == 1) {
        this.testRoundPassed = this.testRound.mainsPassed;
        this.testRoundFailed = this.testRound.mainsFailed;
      }
    },

    async downloadChartData(chart) {
      this.$set(this.downloadLoaders, chart, true);
      try {
        const filters = this.buildTrendlineFilters();
        const response = await DashboardController.downloadTrendlineChartData({
          chart,
          start: filters.start,
          end: filters.end,
          schoolFilter: filters.schoolFilter,
          groupFilter: filters.groupFilter,
          dateFormat: filters.dateFormat,
          viewMode: filters.viewMode,
        });

        if (response?.success) {
          const chartLabel = CHART_DOWNLOAD_LABELS[chart] || chart;
          const viewModeTag = (filters.viewMode || "").replace(/-/g, " ");
          this.downloadCSV(response.data, `${chartLabel}_${viewModeTag}.csv`);
        }
      } finally {
        this.$set(this.downloadLoaders, chart, false);
      }
    },

    downloadCSV(csvData, fileName) {
      const csv = Papa.unparse(csvData);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // 🗓 Get the Sunday of the week for any given date
    getInitialWeekStart(date) {
      const d = new Date(date);
      const dayOfWeek = d.getDay(); // Sunday = 0
      d.setDate(d.getDate() - dayOfWeek); // Go back to Sunday
      d.setHours(0, 0, 0, 0);
      return d;
    },

    // 🗓 Simple week end = Saturday of that week
    getWeekEndDate(startDate) {
      const end = new Date(startDate);
      end.setDate(startDate.getDate() + 6); // Saturday
      end.setHours(23, 59, 59, 999);
      return end;
    },

    // ◀️ Go to previous week (Sunday–Saturday)
    goToPreviousPeriod() {
      
      if (this.activeTab === 1) {
        const prevMonth = new Date(this.monthDate);
        prevMonth.setMonth(prevMonth.getMonth() - 1);

        const sixMonthsAgo = new Date(this.today);
        sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
        sixMonthsAgo.setDate(1); // normalize day to 1

        if (this.isBeforeSixMonthsAgo(prevMonth, sixMonthsAgo)){
          
           return;
        } 
        this.monthDate = prevMonth;
        this.getChartData();
      } else {
        // Week navigation
        const prevWeekEnd = new Date(this.weekStartDate);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - 1);

        let prevWeekStart;
        if (prevWeekEnd.getDay() === 6) {
          prevWeekStart = new Date(prevWeekEnd);
          prevWeekStart.setDate(prevWeekEnd.getDate() - 6);
        } else {
          prevWeekStart = new Date(prevWeekEnd);
          prevWeekStart.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        }

        const sixMonthsAgo = new Date();
        sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
        sixMonthsAgo.setHours(0, 0, 0, 0); // normalize time

        // Prevent going before six months ago
        if (prevWeekStart < sixMonthsAgo) {
          return;
        }
        this.weekStartDate = prevWeekStart;
        this.getChartData();
      }
    },

    // ▶️ Go to next week (Sunday–Saturday)
    goToNextPeriod() {
      this.isPreviousDisabled = false
      if (this.activeTab === 1) {
        // Month navigation
        const nextMonth = new Date(this.monthDate);
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        const now = new Date();

        // Don’t go beyond current month
        if (
          nextMonth.getFullYear() > now.getFullYear() ||
          (nextMonth.getFullYear() === now.getFullYear() &&
            nextMonth.getMonth() > now.getMonth())
        )
          return;

        this.monthDate = nextMonth;
      } else {
        // Week navigation
        const nextWeekStart = new Date(this.weekStartDate);
        nextWeekStart.setDate(nextWeekStart.getDate() + 7);

        const currentWeekStart = this.getInitialWeekStart(this.today);
        if (nextWeekStart > currentWeekStart) return;

        this.weekStartDate = nextWeekStart;
      }
      this.getChartData();
    },
    isBeforeSixMonthsAgo(dateToCheck, referenceDate) {
      const checkYear = dateToCheck.getFullYear();
      const checkMonth = dateToCheck.getMonth();

      const refYear = referenceDate.getFullYear();
      const refMonth = referenceDate.getMonth();

      if (checkYear < refYear) return true;
      if (checkYear === refYear && checkMonth < refMonth) return true;
      return false;
    },

    toggleAllSelection() {
      if (this.isAllSelected) {
        this.selectedSchoolFilter = [];
      } else {
        this.selectedSchoolFilter = [...this.filteredItems];
      }
    },
    toggleAllGroupSelection() {
      if (this.isAllGroupSelected) {
        this.selectedGroupFilter = [];
      } else {
        this.selectedGroupFilter = [...this.filteredGroupItems];
      }
    },
    toggleAllCampaignSelection() {
      if (this.isAllCampaignSelected) {
        this.selectedCampaignFilter = [];
      } else {
        
        this.selectedCampaignFilter = [...this.filteredCampaignItems];
      }
    },

    filterData() {
      this.filterUsersLoader = true;
      this.getFilterCount();
      this.getChartData();
      this.filterUsersLoader = false;
      this.filterDialog = false;
      this.selectedGroupFilter = this.selectedGroupFilter.length <= 0 ? this.groups : this.selectedGroupFilter;
      this.selectedSchoolFilter = this.selectedSchoolFilter.length <= 0 ? this.schoolList: this.selectedSchoolFilter;
      this.selectedCampaignFilter = this.selectedCampaignFilter.length <= 0 ? this.selectedCampaignFilter = this.campaigns.map(campaign => campaign.id).join(',') : this.selectedCampaignFilter;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth is zero-based
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}/${month}/${year}  ${hours}:${minutes}`;
    },

    clearFilter() {
      this.isApply = false;
      this.selectedGroupFilter = [];
      this.selectedSchoolFilter = [];
      this.selectedCampaignFilter = [];
      this.getFilterCount();
      this.getChartData();
    },
    getFilterCount() {
      this.filterCount = [
        this.selectedGroupFilter,
        this.selectedSchoolFilter,
        this.selectedCampaignFilter,
      ].filter((filter) => filter?.length > 0).length;
    },

    async getSchool() {
      const schools = this.$store.state.role.schoolCodes;
      const query = `?schoolCodes=${schools}`;

      const response = await SchoolController.getSchoolByCode(query);
      
      if (response.status == 200) {
        this.schoolsWithCode = response.data.schools;
        this.schoolList = this.schoolsWithCode.map((school) => school.name);
        this.selectedSchoolFilter = this.schoolList;
      } else {
        alert("Schools Not Found!!");
      }
    },
    async getCampaigns() {
      const response = await CampaignController.fetchCampaigns();
      if (response.status == 200) {
        this.campaigns = response.data.campaigns;
        this.selectedCampaignFilter = this.selectedCampaignFilter = this.campaigns.map(campaign => campaign.id).join(',');
      } else {
        alert("Campaigns Not Found!!");
      }
    },
    async getAudienceRoleGroups(){
      const response = await AudienceRolesController.getAudienceRoleGroups();
      if(response.status==200){
        this.groups = response.data.audienceRoleGroup.map(({name}) => name);
        this.selectedGroupFilter = [...this.groups];
      }
    },
  },
  computed: {
    periodLabel() {
      if (this.activeTab === 0) {
        // 🟦 WEEK: Sunday → Saturday
        const start = this.getInitialWeekStart(this.weekStartDate);
        const end = this.getWeekEndDate(start);

        const options = { day: "numeric", month: "long", year: "numeric" };

        const startFormatted = start.toLocaleDateString("en-GB", options); // "5 October 2025"
        const endFormatted = end.toLocaleDateString("en-GB", options); // "11 October 2025"

        const nextWeekStart = new Date(this.weekStartDate);
        nextWeekStart.setDate(nextWeekStart.getDate() + 7);

        const currentWeekStart = this.getInitialWeekStart(this.today);
        if (nextWeekStart > currentWeekStart) {
          this.isNextDisabled = true;
        } else {
          this.isNextDisabled = false;
        }

        const prevWeekEnd = new Date(this.weekStartDate);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - 1);

        let prevWeekStart;
        if (prevWeekEnd.getDay() === 6) {
          prevWeekStart = new Date(prevWeekEnd);
          prevWeekStart.setDate(prevWeekEnd.getDate() - 6);
        } else {
          prevWeekStart = new Date(prevWeekEnd);
          prevWeekStart.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        }

        const sixMonthsAgo = new Date();
        sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
        sixMonthsAgo.setHours(0, 0, 0, 0); // normalize time

        // Prevent going before six months ago
        if (prevWeekStart < sixMonthsAgo) {
          this.isPreviousDisabled = true
        }else{
          this.isPreviousDisabled = false
        }

        this.startOfTheMonth = start;
        this.endOfTheMonth = end;

        return `${startFormatted} - ${endFormatted}`;
      } else {
        const nextMonth = new Date(this.monthDate);
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        const now = new Date();

        // Don’t go beyond current month
        if (
          nextMonth.getFullYear() > now.getFullYear() ||
          (nextMonth.getFullYear() === now.getFullYear() &&
            nextMonth.getMonth() > now.getMonth())
        ) {
          this.isNextDisabled = true;
        } else {
          this.isNextDisabled = false;
        }

        const prevMonth = new Date(this.monthDate);
        prevMonth.setMonth(prevMonth.getMonth() - 1);

        const sixMonthsAgo = new Date(this.today);
        sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
        sixMonthsAgo.setDate(1); // normalize day to 1

        if (this.isBeforeSixMonthsAgo(prevMonth, sixMonthsAgo)){
          this.isPreviousDisabled = true
        }else{
          this.isPreviousDisabled = false
        }
        
        // 🟩 MONTH
        const formattedMonthDate = this.monthDate.toLocaleDateString("en-US", {
          month: "long",
          year: "numeric",
        });
        this.formattedMonthDate = formattedMonthDate;

        return formattedMonthDate;
      }
    },
    filteredItems() {
      let schools = this.schoolList;
      // Remove "All" for filtering purposes
      if (schools.includes("All")) {
        schools = schools.filter((item) => item !== "All");
      }

      if (!this.searchSchoolTerm) return schools;

      const term = this.searchSchoolTerm.toLowerCase();
      return schools.filter((item) => item.toLowerCase().includes(term));
    },
    isAllSelected() {
      return (
        this.filteredItems.length > 0 &&
        this.filteredItems.every((item) =>
          this.selectedSchoolFilter.includes(item)
        )
      );
    },
    filteredGroupItems() {
      if (!this.searchGroupTerm) return this.groups;

      const term = this.searchGroupTerm.toLowerCase();
      return this.groups.filter((item) => item.toLowerCase().includes(term));
    },
    isAllGroupSelected() {
      return (
        this.filteredGroupItems.length > 0 &&
        this.filteredGroupItems.every((item) =>
          this.selectedGroupFilter.includes(item)
        )
      );
    },
    filteredCampaignItems() {
      let campaigns = this.campaigns;

      // Remove "All" for filtering purposes
      if (campaigns.includes("All")) {
        campaigns = campaigns.filter((item) => item.name !== "All");
      }

      if (!this.searchCampaignTerm) return campaigns;

      const term = this.searchCampaignTerm.toLowerCase();
      return campaigns.filter((item) => item.name.toLowerCase().includes(term));
    },
    isAllCampaignSelected() {
      return (
        this.filteredCampaignItems.length > 0 &&
        this.filteredCampaignItems.every((item) =>
          this.selectedCampaignFilter.includes(item.name)
        )
      );
    },
  },
  watch: {
    activeTab(newVal) {
      this.isNextDisabled = false;
      this.isPreviousDisabled = false;
      if (newVal === 0) {
        // Week tab: reset to current week start
        this.weekStartDate = this.getInitialWeekStart(this.today);
      } else {
        // Month tab: reset to current month start
        this.monthDate = new Date(
          this.today.getFullYear(),
          this.today.getMonth(),
          1
        );
        const formattedMonthDate = this.monthDate.toLocaleDateString("en-US", {
          month: "long",
          year: "numeric",
        });
        this.formattedMonthDate = formattedMonthDate;
      }
      this.getChartData();
    },
    activeTestTab(newVal) {
      if (newVal == 0) {
        this.testRoundPassed = this.testRound.screeningPassed;
        this.testRoundFailed = this.testRound.screeningFailed;
      }
      if (newVal == 1) {
        this.testRoundPassed = this.testRound.mainsPassed;
        this.testRoundFailed = this.testRound.mainsFailed;
      }
    },
  },
  async created() {
    this.today.setHours(0, 0, 0, 0);
    this.monthDate = new Date(
      this.today.getFullYear(),
      this.today.getMonth(),
      1
    );
    this.weekStartDate = this.getInitialWeekStart(this.today); // ✅ now returns Oct 5 for Oct 7

    this.bootstrapPromise = Promise.all([
      this.getCampaigns(),
      this.getAudienceRoleGroups(),
    ]);
    await this.bootstrapPromise;
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  async mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
    console.log("this.windowWidth", this.windowWidth);
    if (this.bootstrapPromise) {
      await this.bootstrapPromise;
    }
    await this.getSchool();
    await this.getChartData();
  },
};
</script>
<style>
.custom-container {
  background-color: white;
  width: 100%;
  border-radius: 8px;
  margin: 24px;
  margin-top: 55px;
  margin-right: 55px;
  padding-right: 55px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
}
.custom-gray-text {
  background-color: #cfd5f1 !important;
}
.no-uppercase {
  text-transform: none !important;
}
.icon {
  cursor: pointer;
  transition: opacity 0.3s, filter 0.3s;
}

.disabled-icon {
  opacity: 0.4;
  filter: grayscale(100%);
  cursor: not-allowed;
}
.chart-title {
  font-family: 'GraphikMedium', sans-serif !important;
  font-size: 14px;
  font-weight: 500;
}
</style>
